import { isUndefined } from 'lodash-es';

import { populateSelectedDatapointsMap } from '../../../../core/components/selection-area/utils/populate-selected-datapoints-map.js';
import { selectedToGroupedDataPoints } from '../../../../core/components/selection-area/utils/selected-bins-to-grouped-data-poins.js';
import type { DataPoint } from '../../../../core/types/data-point.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useSelectState } from '../../../hooks/store/selectors.js';
import { useTimeseriesFilteredData } from '../../../hooks/useTimeseriesFilteredData.js';
import { useXScales } from '../../../hooks/useXScale.js';
import { useYScales } from '../../../hooks/useYScales.js';
import { getClusterBoundariesInRange } from '../../../utils/binary-search.js';
import { getDatapointTime } from '../../../utils/timeseries.js';
import { TimeseriesChartDatapoints } from '../TimeseriesExplore/TimeseriesChartDatapoints.js';
import { getDatapointInfo } from './utils/get-datapoint-info.js';
import type { TimeseriesDataPointAllTypes } from '../../displays/shared/types.js';

export const TimeseriesSelectionDatapoints = () => {
  const selectState = useSelectState();
  const { currentScale: xScale } = useXScales();
  const { allDatapoints, datapointsMap } = useTimeseriesFilteredData();
  const yScales = useYScales();
  if (isUndefined(selectState)) {
    return;
  }

  const selectedDatapoints = new Map<string, DataPoint[]>();

  const range: [number, number] = [
    selectState.domainStart.getTime(),
    selectState.domainEnd.getTime(),
  ];

  const [leftIndex, rightIndex] = getClusterBoundariesInRange(
    range,
    allDatapoints,
    (datapoint: TimeseriesDataPointAllTypes) => {
      return getDatapointTime(datapoint.start, datapoint.end);
    },
  );

  if (leftIndex !== -1) {
    // Only iterate over the selected range
    for (let i = leftIndex; i <= rightIndex; i++) {
      const datapoint = allDatapoints[i];
      const currentMetadata = safeGet(datapointsMap, datapoint);
      const datapointKey = `${currentMetadata.start}-${currentMetadata.end}`;

      populateSelectedDatapointsMap(
        selectedDatapoints,
        datapointKey,
        getDatapointInfo(currentMetadata, xScale, yScales),
      );
    }
  }

  const highlightedDatapoints = selectedToGroupedDataPoints(selectedDatapoints);

  return <TimeseriesChartDatapoints groupedPoints={highlightedDatapoints} />;
};

TimeseriesSelectionDatapoints['displayName'] = 'TimeseriesSelectionDatapoints';
